export default function positionOfferTablePriceLabels() {
  const isPresent = document.querySelector(".price-row-buttons");
  if (!isPresent) {
    return;
  }

  // Function to apply or remove padding based on screen width
  function adjustPaddingBasedOnWidth() {
    const mediaQuery = window.matchMedia("(min-width: 1100px)");

    document.querySelectorAll(".offers-table").forEach((table) => {
      const firstRow = table.querySelector("tbody tr:first-child");

      if (firstRow) {
        const lastTd = firstRow.querySelector("td:last-child");

        if (lastTd) {
          const priceRowButton = lastTd.querySelector(".price-row-buttons");

          if (priceRowButton) {
            const buttonWidth = priceRowButton.offsetWidth;

            // Function to add padding when the screen is wider than 1100px
            const addPadding = () => {
              table
                .querySelectorAll(".offers-table-col-5-title")
                .forEach((titleElement) => {
                  titleElement.style.paddingRight = buttonWidth + 16 + "px";
                });
            };

            // Function to remove padding when the screen is narrower than 1100px
            const removePadding = () => {
              table
                .querySelectorAll(".offers-table-col-5-title")
                .forEach((titleElement) => {
                  titleElement.style.paddingRight = ""; // Resets the padding
                });
            };

            // Check the initial screen width and apply/remove padding accordingly
            if (mediaQuery.matches) {
              addPadding();
            } else {
              removePadding();
            }

            // Listen for screen width changes and adjust padding
            mediaQuery.addEventListener("change", (e) => {
              if (e.matches) {
                addPadding();
              } else {
                removePadding();
              }
            });
          }
        }
      }
    });
  }

  function adjustColumnPaddingsSmScreens() {
    // Check if screen width is below 1099px
    if (window.innerWidth < 1099) {
      // Select all elements with class .col-w-price
      const priceColumns = document.querySelectorAll(".col-w-price");

      priceColumns.forEach((column) => {
        // Find the .last-col-price-wrapper within this column
        const priceWrapper = column.querySelector(".last-col-price-wrapper");

        // Find the .offers-table-col-5-title within this column
        const titleElement = column.querySelector(".offers-table-col-5-title");

        if (priceWrapper && titleElement) {
          // Reset padding first to get accurate measurements
          titleElement.style.paddingRight = "0px";

          // Calculate the distance from the right of the column
          const columnRight = column.getBoundingClientRect().right;
          const priceWrapperRight = priceWrapper.getBoundingClientRect().right;
          const rightDistance = columnRight - priceWrapperRight - "4";

          // Apply the calculated distance as right padding to the title element
          titleElement.style.paddingRight = `${rightDistance}px`;
        }
      });
    }
  }

  adjustColumnPaddingsSmScreens();

  window.addEventListener("load", adjustColumnPaddingsSmScreens);
  window.addEventListener("resize", adjustColumnPaddingsSmScreens);

  // Initial call to set the padding based on current screen width
  adjustPaddingBasedOnWidth();
}
